import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'

export default class TriggerTestStart extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
           <ReactTooltip />
          <h2>If certain movements or conditions cause dizziness, then it's called a
          <strong className="text-decoration" data-tip="A condition of the inner ear associated with dizziness. Symptoms are triggered by certain movements or conditions and last for short periods of time."> Triggered Episodic Vestibular Syndrome (t-EVS).</strong></h2>
          <div className="mt-5">
              
              <p>
                If you don’t notice any involuntary eye movements and the dizziness is not constant, we can run a few trigger tests to see if we can get the symptoms to appear.
              </p>
              <p>
                The way symptoms are triggered tells us a lot about what is happening and how to treat it.
              </p>
              
         
              <button className="btn btn-danger mt-5"  onClick={onClick.bind(this,8,false)}>Start the tests</button>
          </div>
         
        </div>

    )
  }
}
